module.exports = __webpack_public_path__ + "img/yasrab.b9caef20.png";